"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarItemFactoryFromJS = exports.ToolbarItemFactory = void 0;
const immutable_1 = require("immutable");
exports.ToolbarItemFactory = (0, immutable_1.Record)({
    actionKey: null,
    disabled: false,
    displayIndex: null,
    icon: null,
    items: (0, immutable_1.List)(),
    options: (0, immutable_1.List)(),
    itemType: 'IButton',
    key: null,
    name: null,
    selected: false,
    text: null,
    value: null,
    onlyIcon: false,
    shortCut: null,
    split: null,
    title: null
});
const ToolbarItemFactoryFromJS = function (data) {
    const items = data.items
        ? data.items.map(function (value) {
            return (0, exports.ToolbarItemFactoryFromJS)(value);
        })
        : [];
    const options = data.options
        ? data.options.map(function (value) {
            return (0, exports.ToolbarItemFactoryFromJS)(value);
        })
        : [];
    return (0, exports.ToolbarItemFactory)(Object.assign(Object.assign({}, data), { items: data.items ? (0, immutable_1.List)(items) : null, options: data.options ? (0, immutable_1.List)(options) : null }));
};
exports.ToolbarItemFactoryFromJS = ToolbarItemFactoryFromJS;
//# sourceMappingURL=IToolbarItem.js.map